import { useEffect, useState } from 'react'

import { Tab } from 'components'
import { ResGetAllContracts } from 'services/Supplier/LogicalEffective'

import RegisterEffectives from './RegisterEffectives'
import SearchRegisterEffectives from './SearchRegisterEffectives'

export interface changeTabProps {
  contractData: ResGetAllContracts
  newValue: number // Tab number
  resetTab?: boolean
}

const LogicalEffective = () => {
  const [tabs, setTabs] = useState(['Pesquisar'])
  const [selectedTab, setSelectedTab] = useState(0)
  const [activeContract, setActiveContract] = useState('')
  const [contractData, setContractData] = useState<ResGetAllContracts | null>(
    null
  )
  const [reset, setReset] = useState(false)

  const handleChangeTab = (props: changeTabProps) => {
    if (props.newValue === 1) {
      setTabs(['Pesquisar', 'Adicionar Novo'])
      setSelectedTab(props.newValue)
      setContractData(props.contractData)
      return
    }

    setSelectedTab(props.newValue || 0)
    setContractData(props.contractData)
    setReset(true)
  }

  useEffect(() => {
    if (contractData) {
      setActiveContract(contractData.cdContrato)
    }
  }, [contractData])

  useEffect(() => {
    if (selectedTab === 0) {
      setTabs(() => ['Pesquisar'])
      setSelectedTab(() => 0)
      setContractData(() => null)
      setReset(() => true)
    }
  }, [selectedTab])

  return (
    <>
      <Tab tabs={tabs} value={selectedTab} handleChange={handleChangeTab} />
      {selectedTab === 0 ? (
        <SearchRegisterEffectives
          handleChangeTab={handleChangeTab}
          activeContract={activeContract}
          reset={reset}
          setReset={() => setReset(false)}
        />
      ) : (
        <RegisterEffectives
          contractData={contractData}
          handleChangeTab={handleChangeTab}
        />
      )}
    </>
  )
}

export default LogicalEffective
